export default {"src":"/_next/static/media/window-double-hung.3c798814.svg","height":1000,"width":1000};